import { createContext, useCallback, useContext, useEffect, useState } from "react";

// Mirrors the "mc_user" localStorage entry that Navbar owns (login/logout still happen
// there - this context just reads the same key and stays in sync via events) so any page
// can check who's logged in and ask the navbar to open its login modal, without every page
// needing its own copy of the login flow.
const AuthContext = createContext({ user: null, requestLogin: () => {} });

function readUser() {
  const saved = localStorage.getItem("mc_user");
  if (!saved) return null;
  try {
    const parsed = JSON.parse(saved);
    return parsed?.token ? parsed : null;
  } catch {
    return null;
  }
}

export function AuthProvider({ children }) {
  const [user, setUser] = useState(readUser);

  useEffect(() => {
    const sync = () => setUser(readUser());
    // "storage" fires for other tabs, "mc_user_changed" for this one (Navbar dispatches it)
    window.addEventListener("storage", sync);
    window.addEventListener("mc_user_changed", sync);
    return () => {
      window.removeEventListener("storage", sync);
      window.removeEventListener("mc_user_changed", sync);
    };
  }, []);

  const requestLogin = useCallback(() => {
    window.dispatchEvent(new Event("mc_open_login"));
  }, []);

  return (
    <AuthContext.Provider value={{ user, requestLogin }}>
      {children}
    </AuthContext.Provider>
  );
}

export function useAuth() {
  return useContext(AuthContext);
}
